import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["teamRow", "bidRow"];
  static values = { showAll: Boolean };

  connect() {
    this.updateVisibility();
  }

  toggleShowAll(event) {
    this.showAllValue = event.target.checked;
    this.updateVisibility();
  }

  updateVisibility() {
    this.teamRowTargets.forEach((row) => {
      const hasBids = row.dataset.hasBids === "true";
      if (this.showAllValue || hasBids) {
        row.style.display = "";
      } else {
        row.style.display = "none";
      }
    });
  }

  toggleBids(event) {
    // Don't toggle if we clicked on a link or a player tag (if it's a link)
    if (event.target.tagName === 'A' || event.target.closest('a')) return;

    const teamId = event.currentTarget.dataset.teamId;
    const bidRows = this.bidRowTargets.filter(r => r.dataset.teamId === teamId);
    
    if (bidRows.length > 0) {
      const isExpanded = event.currentTarget.classList.toggle("is-expanded");
      bidRows.forEach(row => {
        if (isExpanded) {
          row.style.display = "";
          row.classList.remove('hidden');
        } else {
          row.style.display = "none";
          row.classList.add('hidden');
        }
      });
    }
  }
}
